<template>
	<section
		class="flex flex-col space-y-6"
		:class="stacked ? '' : 'md:space-y-0 md:space-x-6 md:flex-row'"
	>
		<ProfileHighlight
			:title="getAdditionalInfoSectionTitle('most_aligned')"
			:items="profileHighlights.mostAligned"
			:embedded="embedded"
		/>

		<ProfileHighlight
			:title="getAdditionalInfoSectionTitle('least_aligned')"
			:items="profileHighlights.leastAligned"
			:embedded="embedded"
		/>
	</section>
</template>

<script>
import personalityResults from '~/mixins/personalityResults'
import ProfileHighlight from './ProfileHighlight.vue'

export default {
	name: 'OverviewProfileHighlights',
	components: {
		ProfileHighlight
	},
	computed: {
		profileHighlights() {
			const role = this.userIsApplicant ? 'applicant' : 'hiring_manager'
			const insights = this.profileByRole?.[role]?.insights || {}

			return {
				mostAligned: insights.mostAligned || [],
				leastAligned: insights.leastAligned || []
			}
		}
	},
	props: {
		jobOfferData: {
			type: Object,
			default: () => {}
		},
		applicantData: {
			type: Object,
			default: () => {}
		},
		wheelMode: {
			type: String,
			required: true
		},
		stacked: {
			type: Boolean,
			default: false
		},
		embedded: {
			type: Boolean,
			default: false
		}
	},
	mixins: [personalityResults],
	methods: {
		getAdditionalInfoSectionTitle(sectionName) {
			return `personality_results.view.${this.highlightHeadingView}.section.${sectionName}`
		}
	}
}
</script>
